<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[20px] md:px-[50px]">
  <div>
    <img class="w-[53px] h-[53px]" src="/assets/v4/bs-google-vr.svg" alt="" />
    <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
    <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
  </div>

  <div class="text-l font-bold mt-[30px]">
    {{ "channel-connect_google_html_标题" | translate }}
    <!-- Connect with Agoda -->
  </div>

  <div class="text-m mt-[30px]">
    <div>
      {{ "channel-connect_google_html_描述" | translate }}
      <!-- Publishing your properties to Google Vacation Rental will increase the chances of your listings being discovered
      and viewed by potential guests, making it more convenient for them to search and book your properties. -->
    </div>
    <!-- Hostex is an official Agoda connectivity partner, so we can connect with your account reliably and securely. -->
  </div>

  <div class="text-m mt-[30px]">
    <div>
      {{ "channel-connect_google_html_注意事项" | translate }}
      <!-- Before you start connecting, you need to know the following things. -->
    </div>

    <ol>
      <li>
        1. {{ "channel-connect_google_html_注意事项1" | translate }}
        <!-- 1. You need to create a Booking Site first and successfully publish it. -->
      </li>
      <li>
        2. {{ "channel-connect_google_html_注意事项2" | translate }}
        <!-- 2. Then visit the Google Vacation Rental section of your Booking Site and publish your listings to Google
        Vacation Rental -->
      </li>
    </ol>
  </div>

  <div class="text-m mt-[30px] md:hidden">
    <div>
      {{ "channel-connect_google_html_mobile_tip" | translate }}
    </div>
  </div>

  <div [class]="footerClass">
    <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="onCancel()">
      {{ "word.cancel" | translate }}
      <!-- Cancel -->
    </button>

    <button
      class="hidden md:block"
      [class]="footerConfirmBtnClass"
      nz-button
      nzType="primary"
      nzSize="large"
      (click)="toBookingsite()">
      {{ "channel-connect_booking_html_to_bookingsite" | translate }}
      <!-- Go to the Booking Site -->
    </button>

    <button
      class="md:hidden"
      [class]="footerConfirmBtnClass"
      nz-button
      nzType="primary"
      nzSize="large"
      hostClipboard
      [clipboardData]="'https://hostex.io'">
      {{ "channel-connect_google_html_copy_url" | translate }}
    </button>
  </div>
</div>
